export default [
    { name:'studentAccount', path: '/studentAccount', component: () => import('@/views/student-programme/components/account'), meta: {
        roles: ['student']
    } },
    { name:'assessment', path: '/assessment', component: () => import('@/views/student-programme/components/assessment'), meta: {
        roles: ['student']
    } },
    { name:'answerResult', path: '/answerResult', component: () => import('@/views/student-programme/components/answerResult'), meta: {
        roles: ['student']
    } },
    // { name:'selectSubscribed', path: '/selectSubscribed', component: () => import('@/views/student-programme/components/selectSubscribed'), meta: {
    //         roles: ['student']
    //     } },
    {
        name: 'selectSubscribed',
        path: '/selectSubscribed',
        component: () => import('@/views/student-programme/components/selectSubscribed'),
        meta: {
            roles: ['student'] // 保留原有角色限制
        }
    },
    {
        name: 'help',
        path: '/help',
        component: () => import('@/views/student-programme/components/help'),
        meta: {
            roles: ['student'] // 保留原有角色限制
        }
    },
    { name:'gacha', path: '/gacha', component: () => import('@/views/student-programme/components/gacha'), meta: {
            roles: ['student']
    } },
    { name:'myGacha', path: '/myGacha', component: () => import('@/views/student-programme/components/myGacha'), meta: {
        roles: ['student']
    } },
]